export default {
  data() {
    return {
      io_observers: {},
      io_intersected: {},
    };
  },
  directives: {
    observer: {
      bind: (el, binding, vnode) => {
        if (vnode.context.$store.state.app.isNode) return;
        if (!binding.value.name) return;
        const { name } = binding.value;
        const observerOptions = binding.value.options || {};
        const callback = binding.value.callback || (() => {});

        if (!vnode.context.io_observers[name]) {
          vnode.context.io_observers[name] = null;
          vnode.context.io_intersected[name] = false;
        }
        if (window && 'IntersectionObserver' in window) {
          vnode.context.io_observers[name] = new IntersectionObserver((entries) => {
            entries.forEach(({ isIntersecting }) => {
              if (isIntersecting) {
                vnode.context.io_intersected[name] = true;
                vnode.context.io_observers[name].unobserve(el);
                callback();
              }
            });
          }, {
            ...observerOptions,
          });
          vnode.context.io_observers[name].observe(el);
        }
      },
      unbind: (el, binding, vnode) => {
        if (!binding.value.name) return;
        if (vnode.context.$store.state.app.isNode) return;
        const { name } = binding.value;
        if (vnode.context.io_intersected[name] === false) {
          vnode.context.io_observers[name].unobserve(el);
        }
      },
    },
  },
};
